import { VatRate } from './enums';
export const FRENCH_VAT_RATES = {
    EXEMPT: VatRate.EXEMPT,
    SUPER_REDUCED: VatRate.SUPER_REDUCED,
    REDUCED: VatRate.REDUCED,
    INTERMEDIATE: VatRate.INTERMEDIATE,
    STANDARD: VatRate.STANDARD,
};
export const VALID_VAT_RATES = Object.values(VatRate);
/**
 * VAT rate numeric values derived from VatRate enum.
 * VatRate enum is the single source of truth.
 */
export const VAT_RATE_VALUES = Object.fromEntries(Object.values(VatRate).map(rate => [rate, parseFloat(rate)]));
